import EllipsisWithTooltip from '@components/atomic/molecules/EllipsisWithTooltip/EllipsisWithTooltip';
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';

const BeneficiaryTile = ({ beneficiary, aggregateTypeChoice, selectedEntity, handleEntitySelect }) => {
	const [isTextLong, setIsTextLong] = useState(false);
	const titleRef = useRef(null);

	useEffect(() => {
		if (titleRef.current) {
			const lineHeightTitle = parseFloat(getComputedStyle(titleRef.current).lineHeight);
			const heightTitle = titleRef.current.scrollHeight;
			const linesTitle = Math.round(heightTitle / lineHeightTitle);

			setIsTextLong(linesTitle > 1);
		}
	}, [beneficiary.companyName]);

	const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

	return (
		<InputGroup className={`aggregate-beneficiary-radio-group ${selectedEntity === beneficiary.companyId ? 'checked-aggregate' : ''}`}>
			<InputGroup.Radio
				id={`${beneficiary.companyId}`}
				name={`${aggregateTypeChoice}-checklist`}
				checked={selectedEntity === beneficiary.companyId}
				onChange={(e) => handleEntitySelect(e, aggregateTypeChoice, beneficiary.companyId, e.target.checked)}
			/>
			<InputGroup.Text className="text-start px-2 py-3" style={{ whiteSpace: 'normal', width: '100%', flex: '1 1 0' }}>
				<Row className="flex-column">
					<Col className="beneficiary-title">
						<ConditionalWrapper
							condition={isTextLong}
							wrapper={(children) => (
								<OverlayTrigger placement="top" overlay={<Tooltip>{beneficiary.companyName}</Tooltip>}>
									<span>{children}</span>
								</OverlayTrigger>
							)}
						>
							<span ref={titleRef} style={{ display: 'block', maxWidth: '100%', width: '100%' }}>
								<EllipsisWithTooltip text={beneficiary.companyName} className="one-line-ellipsis" />
							</span>
						</ConditionalWrapper>
					</Col>
					<Col className="beneficiary-code"><EllipsisWithTooltip text={beneficiary.companyCode} className="one-line-ellipsis" /></Col>
				</Row>
			</InputGroup.Text>
		</InputGroup>
	);
};

export default BeneficiaryTile;
